import { useTranslation } from 'react-i18next';
import { ModalWrapper } from '../ModalWrapper';

export const EvolutionWarning = () => {
  const { t } = useTranslation();

  return (
    <ModalWrapper>
      <div className="px-5 py-[30px] w-full max-w-[328px]">
        <h2 className="text-mg_text_label text-center text-xl font-bold uppercase">
          {t('evolutionWarningModal.title')}
        </h2>
        <p className="text-mg_text text-[15px] font-bold text-center">
          {t('evolutionWarningModal.text')}
        </p>
      </div>
    </ModalWrapper>
  );
};
